
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LineBar from '@/components/organizationDashboard/charts/Line.vue';
import dayjs from 'dayjs';
import Chart from 'chart.js';
import { AggregationResults } from '@/@types/Organization';

@Component({
  components: {
    LineBar,
  },
})
export default class ProcessGraphBase extends Vue {
  @Prop({ required: true })
  private bgColor!: string;
  @Prop({ required: true, default: false })
  private isMoney!: boolean;
  @Prop({ required: true })
  private organizationAggregationResults!: AggregationResults[];

  @Watch('organizationAggregationResults')
  private updateOrganizationAggregationResults(newValue: AggregationResults[]) {
    if (newValue.length) {
      this.organizationAggregationResults = newValue;
      /** 予算か工数かで入れる値を変えている */
      this.scheduleNumber = this.isMoney ? this.organizationAggregationResults[0].totalScheduledBudget : this.organizationAggregationResults[0].totalScheduledManHour;
      this.costNumber = this.isMoney ? this.organizationAggregationResults[0].totalUsedBudget : this.organizationAggregationResults[0].totalUsedManHour;
      /** chartLabelsと等しい年月を持つ組織予実を取得する */
      const searchResults = this.chartLabels.map((yearMonth) => {
        return this.organizationAggregationResults.find((aggregationResult) => {
          return aggregationResult.aggregationMonth === yearMonth.split('-').join('');
        })
      })
      /** 予算か工数かでdataプロパティに入れる値を変えている */
      this.data = searchResults.map((aggregationResult) => {
        if (aggregationResult) {
          return this.isMoney ? aggregationResult?.usedBudget : aggregationResult?.usedManHour;
        } else {
          return 0;
        }
      })
    }
  }

  @Watch('chartLabels')
  private updateChartData(newChartLabels: string[]) {
    /** 新しいchartLabelsと等しい年月を持つ組織予実を取得する */
    const searchResults = newChartLabels.map((yearMonth) => {
      return this.organizationAggregationResults.find((aggregationResult) => {
        return aggregationResult.aggregationMonth === yearMonth.split('-').join('');
      })
    })
    /** 予算か工数かでdataプロパティに入れる値を変えている */
    this.data = searchResults.map((aggregationResult) => {
      if (aggregationResult) {
        return this.isMoney ? aggregationResult?.usedBudget : aggregationResult?.usedManHour;
      } else {
        return 0;
      }
    })
  }

  private costNumber: number = 0;
  private scheduleNumber: number = 0;
  private isOpenMonthPicker: boolean = false;
  private pickedMonth = [dayjs().format('YYYY-MM'), dayjs().subtract(5, 'month').format('YYYY-MM')]
  private chartLabels: string[] = [
    dayjs().subtract(5, 'month').format('YYYY-MM'),
    dayjs().subtract(4, 'month').format('YYYY-MM'),
    dayjs().subtract(3, 'month').format('YYYY-MM'),
    dayjs().subtract(2, 'month').format('YYYY-MM'),
    dayjs().subtract(1, 'month').format('YYYY-MM'),
    dayjs().format('YYYY-MM'),
  ];
  private data: number[] = [];

  /** pickedMonthに合わせてchartLabelsを変更するメソッド */
  private changeChartLabels() {
    const sortedMonthRange = this.sortMonthRange(this.pickedMonth);
    if (sortedMonthRange.length === 1) {
      this.chartLabels = sortedMonthRange;
      return
    } else {
      const from = dayjs(sortedMonthRange[0]);
      const to = dayjs(sortedMonthRange[1]);
      const diff = to.diff(from, 'month');
      const chartLabels = [...Array(diff)].map((_, i) => {
        return from.add(i, 'month').format('YYYY-MM');
      })
      chartLabels.push(to.format('YYYY-MM'));
      this.chartLabels = chartLabels;
      return
    }
  }

  /** pickedMonth配列の一番目が若い年月になるようにソートするメソッド */
  private sortMonthRange(monthRange: string[]) {
    return monthRange.sort((a, b) => {
      const aa = a.split('-').join('');
      const bb = b.split('-').join('');
      return aa < bb ? -1 : (aa > bb ? 1 : 0);
    })
  }

  private get displayMonthRange() {
    const monthRange = this.sortMonthRange(this.pickedMonth);
    if (monthRange.length === 1) {
      return monthRange[0];
    } else {
      return `${monthRange[0]} - ${monthRange[1]}`
    }
  }

  /** グラフ用のデータ */
  private get chartData(): Chart.ChartData {
    return {
      labels: this.chartLabels,
      datasets: [
        {
          label: 'temperature',
          data: this.data,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderColor: 'rgba(255, 255, 255, 1)',
        },
      ],
    };
  }

  /** ラインチャートの設定 */
  private get chartOptions(): Chart.ChartOptions {
    return {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      tooltips: { enabled: false },
      plugins: {
        datalabels: {
          display: false,
        },
      },
      // 軸設定
      scales: {
        // Ｘ軸設定
        xAxes: [
          {
            // 軸ラベル
            scaleLabel: {
              display: false, // 表示設定
            },
            // 補助線
            gridLines: {
              color: 'rgba(255, 255, 255, 0.2)', // 補助線の色
              zeroLineColor: 'rgba(255, 255, 255, 0.2)', // X軸ゼロラインの色
            },
            // 目盛り
            ticks: {
              fontColor: 'white', // 目盛りの色
            },
            id: 'x',
          },
        ],
        // Ｙ軸設定
        yAxes: [
          {
            // 軸ラベル
            scaleLabel: {
              display: false, // 表示の有無
            },
            // 補助線
            gridLines: {
              color: 'rgba(255, 255, 255, 0.2)', // 補助線の色
              zeroLineColor: 'rgba(255, 255, 255, 0.2)', // Y軸ゼロラインの色
            },
            // 目盛り
            ticks: {
              min: 0, // 最小値
              max: Math.max.apply(null, this.data), // 最大値
              stepSize: Math.max.apply(null, this.data) / 5, // 軸間隔
              fontColor: 'white', // 目盛りの色
              beginAtZero: true, // Y軸0からスタート
            },
            id: 'y',
          },
        ],
      },
    };
  }
}
